import { OrganizationOrigin } from '@masar/common/enums';

export const isOrigin = (
    organizationOrigins: OrganizationOrigin[]
): boolean => {
    return organizationOrigins.some(
        origin => window.origin.search(origin) !== -1
    );
};
